import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/Layout";
import LayoutNoSidebar from "../views/layout/LayoutNoSidebar";
import store from "../store";
Vue.use(VueRouter);

export const constantRouterMap = [
	// {
	//   path: "/404",
	//   component: () => import("@/views/error/404"),
	//   hidden: true,
	// },
	// {
	//   path: "*",
	//   component: () => import("@/views/error/PageNotFound"),
	// },

	// {
	//   path: "/404",
	//   component: () => import("@/views/error/404"),

	// },

	{
		path: "/login",
		name: "Login",
		// name:"keycloaklogin",
		component: () => import("@/views/keycloaklogin/keycloaklogin.vue"),
	},

	{
		path: "/profile",
		component: Layout,
		redirect: "/profile",
		meta: {
			title: "Profile",
		},

		children: [
			{
				path: "/",
				name: "Profile",
				component: () => import("@/views/MainProfile.vue"),
				meta: {
					// title: "Profile"
				},
			},
		],
	},

	{
		path: "/register",
		name: "Register",
		component: () => import("../views/keycloaklogin/keycloakregister.vue"),
	},
	{
		path: "/forgot",
		name: "Forgot Password",
		component: () => import("../views/login/Forgotpassword.vue"),
	},
	// {
	//   path: "/register",
	//   component: () => import("../views/login/Register.vue")
	// }

	// {
	//   path: "/404",
	//   component: () => import("@/views/error/PageNotFound"),
	//   hidden: true,
	// },
];

export const asyncRoutes = [
	{
		path: "/",
		component: Layout,
		redirect: "/home",
		meta: {
			roles: ["GET_TOPIC", "GET_TEST"],
			// title: "Topics"
		},
		children: [
			{
				path: "configtable",
				name: "ConfigurationList",
				component: () =>
					import("../views/sandboxes/Configuration/ConfigurationList.vue"),
			},
			{
				path: "addconfig",
				name: "AddConfig",
				component: () =>
					import("../views/sandboxes/Configuration/AddConfiguration.vue"),
			},

			{
				path: "home",
				name: "Home",
				component: () => import("../views/topics/Topics"),
				meta: {
					// title: "Dashboard",
					roles: ["GET_TOPIC"],
				},
			},
			{
				path: "test/:topicID/:topicName",
				name: "Tests",
				component: () => import("../views/test/Tests"),
				meta: {
					// title: "Tests",
					roles: ["GET_TEST"],
				},
			},
			{
				path: "sections/:testName/:testID/:topicName/:topicID",
				name: "QPBuilder",
				component: () => import("../views/sections/QPBuilder.vue"),
				meta: {
					// title: "Sections",
				},
			},
			{
				path: "sharewithpeople/:topicID/:testID",
				name: "ShareWithPeopleTest",
				component: () => import("../views/sharepage/ShareWithPeople.vue"),
				meta: {
					title: "Share",
				},
			},
			{
				path: "configure/:testID/:topicID/:groupID/:groupType",
				name: "ConfigureTest",
				component: () => import("../views/sharepage/Configure.vue"),
				meta: {
					title: "Configure",
				},
			},
			{
				path: "addconfigure/:testID/:groupID/:topicID/:groupType",
				name: "ParticularTestConfigurationTest",
				component: () =>
					import("../views/sharepage/ParticularTestConfiguration.vue"),
				meta: {
					title: "Add Configuration",
				},
			},
			{
				path: "editconfigure/:testID/:groupID/:topicID/:groupType",
				name: "EditConfigurationTest",
				component: () => import("../views/sharepage/EditConfiguration.vue"),
				meta: {
					title: "EditConfiguration",
				},
			},
			{
				path: "viewconfigure/:testID/:groupID/:topicID/:groupType",
				name: "ViewConfigurationTest",
				component: () => import("../views/sharepage/ViewConfiguration.vue"),
				meta: {
					title: "ViewConfiguration",
				},
			},
			{
				path: "archivetest",
				name: "Archivetest",
				component: () => import("../views/ArchiveTest/Archivetest.vue"),
				meta: {
					// title: "Archive Tests",
				},
			},
			{
				path: "codingtestqp",
				name: "QPCodingTest",
				roles: ["GET_CODING_TEST"],
				component: () => import("../views/codingtest/QPcodingTest.vue"),
				meta: {
					title: "QP Coding Test",
				},
			},
		],
	},
	{
		path: "/proctoring",
		redirect: "/proctoring/dashboard",
		component: Layout,
		meta: {
			// title: "Proctoring ",
			roles: ["GET_PROCTORING", "GET_EVALUATOR_TEST"],
		},
		children: [
			{
				path: "dashboard",
				name: "ProctoringDashboard",
				component: () => import("../views/Proctoring/ProctoringDashboard"),
				meta: {
					// title: "Dashboard",
				},
			},
			{
				path: "proctortest/:groupID/:candidateType",
				name: "ViewProctorTestScreen",
				component: () => import("../views/Proctoring/ViewProctorTestScreen"),
				meta: {
					// title: "Proctor Test Screen",
				},
			},
			{
				path:
					"candidateproctor/:testID/:topicID/:groupID/:candidateID/:candidateType",
				name: "candidateproctor",
				component: () =>
					import("../views/Proctoring/ViewCandidateProctorScreen"),
				meta: {
					// title: "Candidate Proctor Details",
				},
			},
			{
				path:
					"evaluatetest/:testID/:topicID/:groupID/:candidateID/:candidateType",
				name: "evaluatetest",
				// name:"keycloaklogin",
				component: () => import("@/views/Proctoring/EvaluateTestscreen.vue"),
			},
		],
	},
	{
		path: "/sandboxes",
		component: Layout,
		children: [
			{
				path: "/myprojects",
				name: "myprojects",
				component: () => import("../views/sandboxes/MyProjects.vue"),
				meta: {
					title: "My Projects",
				},
			},
			{
				path: "/createprojects",
				name: "createprojects",
				component: () => import("../views/sandboxes/CreateProject.vue"),
				meta: {
					title: "Create Projects",
				},
			},
			{
				path: "/editprojects/:id",
				name: "editprojects",
				component: () => import("../views/sandboxes/CreateProject.vue"),
				meta: {
					title: "Edit Project",
				},
			},
			{
				path: "/adminconsole",
				name: "adminconsole",
				component: () => import("../views/sandboxes/AdminConsole.vue"),
				meta: {
					title: "Admin Console",
				},
			},
			{
				path: "/editsandbox/:id",
				name: "editsandbox",
				component: () => import("../views/sandboxes/EditSandBox.vue"),
				meta: {
					title: "Edit Sandbox",
				},
			},
			{
				path:
					"/view-code-sandbox/:testID/:testUUID/:attemptNo/:topicID/:groupID/:userID/:emailID",
				name: "view-code-sandbox",
				component: () => import("../views/sandboxes/ViewCodeSandbox.vue"),
				meta: {
					title: "View Code Sandbox",
				},
			},
			{
				path: "/sharewithpeople/:topicID/:testID/",
				name: "sharesandbox",
				component: () => import("../views/sharepage/ShareWithPeople.vue"),
				meta: {
					title: "Share",
				},
			},
			{
				path: "/configure/:testID/:topicID/:groupID/:groupType",
				name: "configuresandbox",
				component: () => import("../views/sharepage/Configure.vue"),
				meta: {
					title: "Configure",
				},
			},
			{
				path: "/addconfigure/:testID/:groupID/:topicID/:groupType",
				name: "addconfigsandbox",
				component: () =>
					import("../views/sharepage/ParticularTestConfiguration.vue"),
				meta: {
					title: "Add Configuration",
				},
			},
			{
				path: "/editconfigure/:testID/:groupID/:topicID/:groupType",
				name: "editconfigsandbox",
				component: () => import("../views/sharepage/EditConfiguration.vue"),
				meta: {
					title: "Edit Configuration",
				},
			},
			{
				path: "/viewconfigure/:testID/:groupID/:topicID/:groupType",
				name: "viewconfigsandbox",
				component: () => import("../views/sharepage/ViewConfiguration.vue"),
				meta: {
					title: "View Configuration",
				},
			},
		],
	},

	{
		path: "/questionbank",
		component: Layout,
		meta: {
			roles: ["GET_QUESTION_BANK", "GET_CODING_TEST"],
		},
		children: [
			{
				path: "/",
				name: "questionbank",
				component: () => import("../views/questionbank/QuestionBank.vue"),
				meta: {
					title: "Question Bank",
				},
			},
			{
				path: "/communication",
				name: "communicationTestQB",
				component: () => import("../views/questionbank/QuestionBank.vue"),
				meta: {
					title: "Question Bank",
				},
			},
			{
				path: "codingtestqp",
				name: "QPcodingTest",
				component: () => import("../views/codingtest/QPcodingTest.vue"),
				meta: {
					title: "QP Coding Test",
				},
			},
			{
				path: "codingtestqp/codingtest/createquestion",
				name: "BuildingCodeTest",
				component: () => import("../views/codingtest/BuildCodingTest.vue"),
			},
			{
				path: "codingtestqp/codingtest/editquestion",
				name: "EditCodingTest",
				component: () => import("../views/codingtest/EditCodingTest.vue"),
			},
			{
				path: "codingtestqp/codingtest/previewquestion",
				name: "PreviewCodeTest",
				component: () => import("../views/codingtest/PreviewCodeTest.vue"),
			},
			{
				path: "codingtestqp/codingtest/trycode",
				name: "tryCode",
				component: () => import("../views/codingtest/tryCode.vue"),
			},
		],
	},
	{
		path: "/transaction",
		component: Layout,
		meta: {
			roles: ["GET_TRANSACTION"],
		},
		children: [
			{
				path: "/",
				name: "Transaction",
				component: () => import("../views/Transaction.vue"),
				meta: {
					title: "Transaction",
				},
			},
		],
	},
	{
		path: "/groups",
		component: Layout,
		redirect: "/groups/individual",
		meta: {
			roles: ["GET_GROUP", "GET_INDIVIDUAL"],
		},
		children: [
			{
				path: "individual",
				name: "Group",
				component: () => import("../views/group/Group.vue"),
				meta: {
					title: "Individual / Group",
				},
			},
		],
	},
	{
		path: "/qp",
		component: Layout,
		meta: {
			roles: ["GET_AUTOGENERATE"],
		},
		children: [
			{
				path: "sharewithpeople/:topicID/:testID/:testName",
				name: "ShareWithPeopleAutoQPBuilder",
				component: () => import("../views/sharepage/ShareWithPeople.vue"),
				meta: {
					title: "Share",
				},
			},
			{
				path: "configure/:testID/:topicID/:groupID/:testName/:groupType",
				name: "ConfigureAutoQPBuilder",
				component: () => import("../views/sharepage/Configure.vue"),
				meta: {
					title: "Configure",
				},
			},
			{
				path: "addconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "ParticularTestConfigurationAutoQPBuilder",
				component: () =>
					import("../views/sharepage/ParticularTestConfiguration.vue"),
				meta: {
					title: "Add Configuration",
				},
			},
			{
				path: "editconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "EditConfigurationAutoQPBuilder",
				component: () => import("../views/sharepage/EditConfiguration.vue"),
				meta: {
					title: "EditConfiguration",
				},
			},
			{
				path: "viewconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "ViewConfigurationAutoQPBuilder",
				component: () => import("../views/sharepage/ViewConfiguration.vue"),
				meta: {
					title: "ViewConfiguration",
				},
			},
		],
	},
	{
		path: "/share",
		component: Layout,

		children: [
			{
				path: "sharewithpeople/:topicID/:testID",
				name: "ShareWithPeople",
				component: () => import("../views/sharepage/ShareWithPeople.vue"),
				meta: {
					title: "Share",
				},
			},
			{
				path: "configure/:testID/:topicID/:groupID/:groupType",
				name: "Configure",
				component: () => import("../views/sharepage/Configure.vue"),
				meta: {
					title: "Configure",
				},
			},
			{
				path: "addconfigure/:testID/:groupID/:topicID/:groupType",
				name: "ParticularTestConfiguration",
				component: () =>
					import("../views/sharepage/ParticularTestConfiguration.vue"),
				meta: {
					title: "Add Configuration",
				},
			},
			{
				path: "editconfigure/:testID/:groupID/:topicID/:groupType",
				name: "EditConfiguration",
				component: () => import("../views/sharepage/EditConfiguration.vue"),
				meta: {
					title: "EditConfiguration",
				},
			},
			{
				path: "viewconfigure/:testID/:groupID/:topicID/:groupType",
				name: "ViewConfiguration",
				component: () => import("../views/sharepage/ViewConfiguration.vue"),
				meta: {
					title: "ViewConfiguration",
				},
			},
		],
	},

	{
		path: "/permission",
		component: Layout,
		redirect: "/permission/access",
		meta: {
			roles: ["admin", "VIEW_ADMIN", "GET_ROLE", "GET_EVALUATOR"],
		},
		children: [
			{
				path: "access",
				name: "AccessControl",
				component: () => import("../views/admin/AccessPanel.vue"),
				meta: {
					title: "Access Control",
				},
			},

			{
				path: "evaluator/dashboard",
				name: "EvaluatorList",
				component: () => import("../views/Evaluator/EvaluatorList.vue"),
				meta: {
					title: "Evaluator List",
				},
			},
			{
				path: "evaluator/addevaluator",
				name: "AddEvaluator",
				component: () => import("../views/Evaluator/AddEvaluator.vue"),
				meta: {
					title: "Add Evaluator",
				},
			},
			{
				path: "evaluator/editevaluator/:evaluatorID",
				name: "EditEvaluator",
				component: () => import("../views/Evaluator/EditEvaluator.vue"),
				meta: {
					title: "Edit Evaluator",
				},
			},
			// {
			//   path: "AddRolesAccess",
			//   name: "AddRolesAccess",
			//   component: () => import("@/views/admin/roles/AddRolesAccess"),
			//   meta: {
			//     title: "Add Role",
			//   },
			// },
			// {
			//   path: "EditRoles",
			//   name: "EditRoles",
			//   component: () => import("@/views/admin/roles/EditRoles"),
			//   meta: {
			//     title: "Edit Role",
			//   },
			// },
			// {
			//   path: "AddUserAccess",
			//   name: "AddUserAccess",
			//   component: () => import("@/views/admin/user/AddUserAccess"),
			//   meta: {
			//     title: "User",
			//   },
			// },
		],
	},
	{
		path: "/autogenerate",
		component: Layout,
		meta: {
			// title: "AutoGenerate Test",
			roles: ["GET_AUTOGENERATE"],
		},
		children: [
			{
				path: "/",
				name: "AutogenerateTest",
				component: () => import("../views/autoGenerate/AutogenerateTest.vue"),
				meta: {
					// title: "Dashboard"
				},
			},
			{
				path: "autosection",
				name: "AutogenerateSection",
				component: () =>
					import("../views/autoGenerate/AutogenerateSection.vue"),
				meta: {
					// title: "Auto Section",
				},
			},
			{
				path: "autosections/:testID/:testName/:topicID/",
				name: "AutoQPBuilder",
				component: () => import("../views/autoGenerate/AutoQPBuilder.vue"),
				meta: {
					// title: "Sections",
				},
			},

			{
				path: "sharewithpeople/:topicID/:testID/:testName",
				name: "ShareWithPeopleAutogenerate",
				component: () => import("../views/sharepage/ShareWithPeople.vue"),
				meta: {
					title: "Share",
				},
			},
			{
				path: "configure/:testID/:topicID/:groupID/:testName/:groupType",
				name: "ConfigureAutogenerate",
				component: () => import("../views/sharepage/Configure.vue"),
				meta: {
					title: "Configure",
				},
			},
			{
				path: "addconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "ParticularTestConfigurationAutogenerate",
				component: () =>
					import("../views/sharepage/ParticularTestConfiguration.vue"),
				meta: {
					title: "Add Configuration",
				},
			},
			{
				path: "editconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "EditConfigurationAutogenerate",
				component: () => import("../views/sharepage/EditConfiguration.vue"),
				meta: {
					title: "EditConfiguration",
				},
			},
			{
				path: "viewconfigure/:testID/:groupID/:topicID/:testName/:groupType",
				name: "ViewConfigurationAutogenerate",
				component: () => import("../views/sharepage/ViewConfiguration.vue"),
				meta: {
					title: "ViewConfiguration",
				},
			},
		],
	},
	//Reports sub-section starts here
	{
		path: "/reports",
		redirect: "/reports/overall",
		component: Layout,
		meta: {
			roles: ["GET_REPORTS"],
		},
		children: [
			{
				path: "overall",
				name: "OverallAssessment",
				component: () =>
					import("../views/reports/overall/OverallAssessment.vue"),
				meta: {
					title: "Reports",
				},
			},
			{
				path: "topic/:topicID",
				name: "TopicReport",
				component: () => import("../views/reports/topic/TopicReport.vue"),
				meta: {
					title: "Topic Report",
				},
			},
			{
				path: "test/:topicID/:testID",
				name: "IndividualTest",
				component: () => import("../views/reports/test/IndividualTest.vue"),
				meta: {
					title: "Test Report",
				},
			},
			{
				path: "candidate/:testID/:candidateID/:candidateName",
				name: "CandidatePerformance",
				component: () =>
					import("../views/reports/candidate/CandidatePerformance.vue"),
				meta: {
					title: "Candidate Performance Report",
				},
			},
			{
				path: "question-quality/:testID",
				name: "QuestionQuality",
				component: () => import("../views/reports/QuestionQuality.vue"),
				meta: {
					title: "Question Quality Report",
				},
			},
		],
	},
	{
		path: "/404",
		component: LayoutNoSidebar,
		children: [
			{
				path: "/",
				name: "404",
				component: () => import("@/views/error/PageNotFound"),
				meta: {
					title: "PageNotFound",
				},
			},
		],
	},

	{ path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
	new VueRouter({
		mode: "history",
		scrollBehavior: () => ({ y: 0 }),
		routes: constantRouterMap,
	});

const router = createRouter();

export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}

router.beforeEach((to, from, next) => {
	console.log(to);
	if (!to.path.startsWith("/proctoring")) {
		store.commit("testVUEX/clearProctoringFilters"); // ✅ reset
	}
	next();
});

export default router;
const onError = (e) => {
	// avoid NavigationDuplicated
	if (e.name !== "NavigationDuplicated") throw e;
};

// keep original function
const _push = Object.getPrototypeOf(router).push;

// then override it
const newRouter = Object.create(router);
newRouter.push = function push(...args) {
	try {
		const op = _push.call(this, ...args);
		if (op instanceof Promise) op.catch(onError);
		return op;
	} catch (e) {
		onError(e);
	}
};
